export function slugify(str?: string, delimiter = '-') {
  const replacements = ['o', 'e', 'y', 'u', 'i', 'o', 'd', 'a', 'ae', 'th'];
  return encodeURIComponent(
    (str || '')
      .toLocaleLowerCase()
      .replace(/\s+/g, delimiter)
      .replace(
        new RegExp(`[^a-z0-9${delimiter}]`, 'g'),
        (x) => replacements['öéýúíóðáæþ'.indexOf(x)] || '',
      ),
  );
}
